export const BOOKING_RECEIVED = 'BOOKING_RECEIVED';
export const FETCH_BOOKING_FILES_SUCCESS = 'FETCH_BOOKING_FILES_SUCCESS';
export const FETCH_RECENT_BOOKING_FILES_SUCCESS = 'FETCH_RECENT_BOOKING_FILES_SUCCESS';
export const FETCH_CHITCHAT_MESSAGES_BEGIN = 'FETCH_CHITCHAT_MESSAGES_BEGIN';
export const FETCH_CHITCHAT_MESSAGES_SUCCESS = 'FETCH_CHITCHAT_MESSAGES_SUCCESS';
export const FETCH_CHITCHAT_MESSAGES_FAILURE = 'FETCH_CHITCHAT_MESSAGES_FAILURE';
